import { useEffect, useState } from "react";

export function BidderAvatar({ name, src, large = false }: { name: string; src: string | null; large?: boolean }) {
  const [imageFailed, setImageFailed] = useState(false);
  useEffect(() => setImageFailed(false), [src]);
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join("").toUpperCase() || "K";
  return (
    <span className={`grid shrink-0 place-items-center overflow-hidden rounded-full bg-navy-50 font-bold text-navy ${large ? "h-14 w-14 text-lg" : "h-12 w-12 text-sm"}`}>
      {src && !imageFailed ? <img src={src} alt="" className="h-full w-full object-cover" onError={() => setImageFailed(true)} /> : initials}
    </span>
  );
}
